export default "__VITE_PUBLIC_ASSET__7f38635d__"